<template>
    <v-app>
        <router-view></router-view>         
    </v-app>
</template>
<script>
import axios from 'axios'


axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';
export default {

}
</script>